const emptyFieldValues = ['', undefined, null]

const isRecord = (
  value: string | number | Record<string, unknown> | boolean | undefined
): value is Record<string, unknown> => typeof value === 'object' && value !== null

/**
 * Checks if input value is provided.
 * Might be helpful to set the 'isFilled' state for the input
 */
export const isFieldValueSet = (
  value: string | number | Record<string, unknown> | boolean | undefined
): boolean => {
  if (typeof value === 'number' || typeof value === 'boolean' || isRecord(value)) {
    return true
  }
  return !emptyFieldValues.includes(value)
}
